<div class="cwan-gpt-chat-container">
  <prompt-template></prompt-template>
</div>
